import React, {CSSProperties} from 'react'
import {Icon} from '@components/common/base/icon'
import {TablerIcons} from '@components/common/icon-tabler/icon-tabler'

export interface IconProps {
  icon: TablerIcons
  size?: 12 | 16 | 20 | 24 | 32
  className?: string
  style?: CSSProperties
  onClick?: (e: React.MouseEvent) => void
}

export const SharedIcon = React.forwardRef<HTMLDivElement, IconProps>(
  (props: IconProps, ref) => {
    const {icon, size = 16, className, style, onClick} = props

    return (
      <Icon
        icon={icon}
        size={size}
        className={className}
        style={style}
        onClick={onClick}
        ref={ref}
      />
    )
  }
)
